import { Box, CardMedia, Typography } from '@mui/material'
import React from 'react'

const MainHeader = ({ image, title, description, Icon }) => {
    return (
        <Box sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-evenly',
            flexDirection: 'column',
            m: 1,
            p: 2,
            textAlign: 'center'
        }}>
            {image ? (
                <CardMedia
                    component={'img'}
                    src={image}
                    sx={{ width: '100px', height: '100px', objectFit: 'contain' }}
                />
            ) : (
                Icon && <Box sx={{ fontSize: 70, color: 'primary.main' }}>{<Icon sx={{ width: '2.5rem', height:'2.5rem' }} />}</Box>
            )}
            <Typography color={'primary.default'} variant="h6" fontWeight={'bold'}>
                {title}
            </Typography>
            <Typography color={'secondary.default'} variant='body2' fontWeight={'bold'}>
                {description}
            </Typography>
        </Box>
    )
}

export default MainHeader
